import moment from "moment/moment";
import React from "react";
import { Modal } from "react-bootstrap";
import "./AddPromotionalBannerComponent.css";

const AddPromotionalChangePointModal = ({
  handleCloseChangePointModal,
  changePointModal,
  impressionForm,
  setImpressionForm,
  handleUpdateBannerImpression
}) => {
  return (
    <div>
      <Modal
        show={changePointModal}
        onHide={handleCloseChangePointModal}
        backdrop="static"
        className="edit-group-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Banner Impression</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label for="mrp" className="form-label">
              Update Impression
            </label>
            <input id="mrp" className="form-control" type="number" onChange={(e)=>setImpressionForm(e.target.value)} value={impressionForm}/>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" className="common_btn btn-secondary" data-bs-dismiss="modal" >Cancel</button>
        <button type="button" className="common_btn view-data-btn" onClick={handleUpdateBannerImpression}>Update</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddPromotionalChangePointModal;
